import axios from "axios";
import { getApiUrl } from "@/hooks/apiConfig";
import { notNullCheck, getCookie, checkDevice, indentifyForm, getLocal, delay, CustomAlert, handleSuccess, handleError, hostfunction, removeLocal, setCookie } from "@/Snnipets/helper";
import { UserIPStore, UserIPv6, gclidDate, gclidData, referralLink, landingPage, indexurl, gclidName } from "@/lib/variables";

async function formSuccessLog(formdatacollect) {
  try {
    const requestData = {
      dateandtime: new Date().toLocaleString("en-CA", {
        timeZone: "Asia/Kolkata",
        hour12: false,
      }),
      logid: "formSuccessLog",
      countrycode: formdatacollect.get("countrycode") || "",
      type: formdatacollect.get("type") || "",
      apiId: formdatacollect.get("apiId") || "",
      url: formdatacollect.get("url") || "",
      UserIP: formdatacollect.get("UserIP") || "",
      UserIPv6: formdatacollect.get("UserIPv6") || "",
      landingPage: formdatacollect.get("landingPage") || "",
      referralLink: formdatacollect.get("referralLink") || "",
      sourceleadid: formdatacollect.get("sourceleadid") || "",
      indexurl: formdatacollect.get("indexurl") || "",
      referral: formdatacollect.get("referral") || "",
      devicecategory: formdatacollect.get("devicecategory") || "",
    };

    const response = await axios.post(`${process.env.NEXT_PUBLIC_FAILPROCCESSAPI}/failprocess/logs/log_create.php`, requestData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 10000,
    });

    if (response?.data?.statusCode === 200) {
      // ✅ success
      // console.log("Form success log saved");
    }
  } catch (error) {
    console.error("FormSuccessLog Error:", error?.response || error);
  }
}

function clearLocalData() {
  removeLocal(indexurl);
  removeLocal(gclidData);
  removeLocal(gclidName);
  removeLocal(gclidDate);
  setCookie(referralLink, "", 0);
  setCookie(landingPage, "", 0);
}

function setLoading(action = "hide", selector = ".loading1") {
  if (typeof window === "undefined") return;

  const el = document.querySelector(selector);
  if (!el) return;

  const type = String(action).toLowerCase();

  if (type === "show") {
    el.style.display = "block";
    el.setAttribute("aria-busy", "true");
  } else {
    el.style.display = "none";
    el.removeAttribute("aria-busy");
  }
}


// ------------------- ✅ MAIN FUNCTION ------------------- //
export async function CommonSubmitForm(identifyform, rawData, btntype) {
  setLoading("show");
  const apiURL = getApiUrl();
  const maxRetries = 1;

  const { GtagPath, formid } = indentifyForm(identifyform);

  let formElement = document.getElementById(formid);

  const finalData = new FormData();

  /* ---------- Append Raw Form Data ---------- */
  Object.entries(rawData || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      finalData.append(key, value);
    }
  });

  /* ---------- Append File (if exists) ---------- */
  const fileInput = formElement?.querySelector('input[type="file"]');
  if (fileInput?.files?.length) {
    finalData.append(fileInput.name, fileInput.files[0]);
  }

  // Extract and append country code to the FormData object
  var country_data = formElement.querySelector(".selected-flag").title;
  if (country_data) {
    var code = country_data.split(": +");
  }

  const predefinedData = {
    type: 8,
    apiId: identifyform,
    sourceleadid: notNullCheck(getLocal(gclidData)) ? 1 : 2,
    indexurl: window.location.href,
    landingPage: notNullCheck(getCookie(landingPage)) ? getCookie(landingPage) : "",
    referralLink: notNullCheck(getCookie(referralLink)) ? getCookie(referralLink) : "",
    referral: hostfunction(),
    gclidData: notNullCheck(getLocal(gclidData)) ? getLocal(gclidData) : "",
    gclidName: notNullCheck(getLocal(gclidName)) ? getLocal(gclidName) : "",
    gclidDate: notNullCheck(getLocal(gclidDate)) ? getLocal(gclidDate) : "",
    url: window.location.href.split("#")[0],
    UserIP: getCookie(UserIPStore),
    UserIPv6: getCookie(UserIPv6),
    devicecategory: checkDevice(),
    countrycode: code[1],
  };

  Object.entries(predefinedData).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      finalData.append(key, value);
    }
  });

  // Append predefined data INTO FormData
  // -------------------------------
  // Append predefined data
  // -------------------------------
  let mainerror = null;

  if ((rawData.email && rawData.email.trim()) || (rawData.mobile && rawData.mobile.trim())) {
    try {
      let attempt = 0;
      let success = false;
      let mainResponse = null;

      // ---- RETRY LOOP ----
      while (attempt < maxRetries && !success) {
        attempt++;

        try {
          mainResponse = await axios.post(`${apiURL}/Website/contactusadd`, finalData, {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: 40000,
          });

          const data = mainResponse?.data;

          if (!data || typeof data.statusCode === "undefined") {
            console.warn(`Attempt ${attempt}: Invalid main API response`);
          } else if (data.statusCode === 1) {
            handleSuccess({
              title: "",
              message:
                "We’re eager to learn more about your vision and explore how we can deliver the right solutions to support your growth. With experience serving global brands, our team is equipped to bring strategic value and innovation to the table. One of our representatives will be in touch shortly to initiate a meaningful conversation. We look forward to a successful collaboration ahead.",
              type: "success",
            });
            clearLocalData();
            if (typeof gtag === "function") {
              gtag("event", "page_view", {
                page_path: GtagPath,
                page_location: window.location.host + GtagPath,
              });
            } else {
              console.error("❌ gtag is not defined");
            }
            success = true;
            formSuccessLog(finalData); // this is form success log when main api call success
            return { success: true };
          } else if (data.statusCode === 101) {
            console.warn("⚠️ Request limit exceeded!");
            CustomAlert("Request limit exceeded!", "Sorry, You have already submitted multiple forms.", "warning");
            formSuccessLog(finalData); // this is form success log when main api call success
            return { success: false, error: "limit_exceeded" };
          } else if (data.statusCode === 0) {
            console.error("Main API failure, running fail process...");
            success = false;
            return await handleFailProcess(finalData, "Main API failure, Giving Status Code : 0");
          } else {
            console.error(`Attempt ${attempt}: Main API failed with code ${data.statusCode}`);
          }
        } catch (err) {
          console.error(`🚨 Attempt ${attempt} failed with error:`, err);
          // Safely extract error message
          const responseData = err?.response?.data ? JSON.stringify(err.response.data) : "Main API processing error";
          mainerror = `${err.message}\n${responseData}`;
        }

        // Wait before retry (exponential backoff)
        if (!success && attempt < maxRetries) await delay(1500 * attempt);
      }

      if (!success) {
        console.error("❌ All main API attempts failed. Running fail process...");
        return await handleFailProcess(finalData, mainerror);
      }
    } catch (error) {
      console.error("🚨 Main API process error:", error);
      // Safely extract error message
      const responseData = err?.response?.data ? JSON.stringify(err.response.data) : "Main API processing error";
      mainerror = `${err.message}\n${responseData}`;
      return await handleFailProcess(finalData, mainerror);
    } finally {
      setLoading("hide");
    }
  } else {
    console.log("Invalid Values");
  }
}

// ------------------- ⚙️ FAIL PROCESS ------------------- //
async function handleFailProcess(finalData, reason = "Unknown error") {
  setLoading("show");
  finalData.append("error", reason);

  const { GtagPath } = indentifyForm(finalData.apiId);

  try {
    const fallbackResponse = await axios.post(`${process.env.NEXT_PUBLIC_FAILPROCCESSAPI}/failprocess/failprocess.php`, finalData, {
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 40000,
    });

    if (fallbackResponse?.data?.statusCode === 200 || fallbackResponse?.data?.phpstatusCode === 200) {
      handleSuccess({
        title: "",
        message:
          "We’re eager to learn more about your vision and explore how we can deliver the right solutions to support your growth. With experience serving global brands, our team is equipped to bring strategic value and innovation to the table. One of our representatives will be in touch shortly to initiate a meaningful conversation. We look forward to a successful collaboration ahead.",
        type: "success",
      });
      clearLocalData();
      if (typeof gtag === "function") {
        gtag("event", "page_view", {
          page_path: GtagPath,
          page_location: window.location.host + GtagPath,
        });
      } else {
        console.error("❌ gtag is not defined");
      }
      return { success: true, fallback: true };
    }
    if (fallbackResponse?.data?.statusCode === 429) {
      handleError({
        title: "Request limit exceeded!",
        message: "Sorry, You have already submitted multiple forms.",
        type: "warning",
      });
      return { success: false, fallback: true };
    } else {
      handleError({
        title: "Process Failed!",
        message: "Sorry, an error occurred while processing your request. Please try again later.",
        type: "failure",
      });
    }
  } catch (err) {
    console.error("🚨 Fail process encountered an error:", err.message);
    handleError({
      title: "Process Failed!",
      message: "Sorry, an error occurred while processing your request. Please try again later.",
      type: "failure",
    });
    return { success: false, error: err.message || "fail_process_error" };
  } finally {
    setLoading("hide");
  }
}
